'use client';

import { Suspense } from 'react';
import SearchBar from '@/app/_components/searchbar';

export const HomeHeroBannerSearchForm: React.FC<{ title: string; subtitle: string; defaultService?: string }> = ({
  title,
  subtitle,
  defaultService = '',
}) => {
  return (
    <div className="relative z-[3] xl:flex xl:flex-row">
      <div className="shadow-1 relative flex flex-col gap-6 rounded-xl border border-black/5 bg-white p-6">
        <div className="flex flex-row gap-4">
          <h2 className="font-medium md:text-lg">{title}</h2>
        </div>
        <p>{subtitle}</p>
        <div className="hidden md:block">
          <Suspense>
            <SearchBar idPrefix="searchBarDesktop" inline defaultService={defaultService} />
          </Suspense>
        </div>
        <div className="block md:hidden">
          <Suspense>
            <SearchBar idPrefix="searchBarMobile" defaultService={defaultService} />
          </Suspense>
        </div>
      </div>
    </div>
  );
};
